import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddProductCategory = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onAddCategorySubmit,
  isUpdateButton,
  isEditMode,
  setIsUpdateButton,
  setValue
}) => {
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode ? "Add Product Category" : "Edit Product Category"}
              </b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="Category Code"
                        name="categoryCode"
                        fullWidth
                        placeholder="Enter category code"
                        size="small"
                        required
                        autoComplete="off"
                        {...register("categoryCode", { required: true })}
                        error={Boolean(errors?.categoryCode)}
                        helperText={errors?.categoryCode?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("categoryCode", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="Category Name"
                        name="categoryName"
                        placeholder="Enter category name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("categoryName", { required: true })}
                        error={Boolean(errors?.categoryName)}
                        helperText={errors?.categoryName?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("categoryName", str.trim());
                         
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddCategorySubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddProductCategory;
